import ExpectedAnswerImport from './expectedanswerimport'

export default ExpectedAnswerImport